import type { YesNoOptionValue } from '~shared/constants/yes-no-options';

export function formatYesNo(value: YesNoOptionValue): boolean {
  return value === 'yes';
}

export function recoverYesNo(value: boolean): YesNoOptionValue {
  return value ? 'yes' : 'no';
}
